import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { SdkStateServicePageConfig } from '../types'
import { name } from '../symbols'

const sdkStateServicePageConfig: PageConfigFn<SdkStateServicePageConfig> = ({ api }: VsmContext, _pageId: string) => {
	const isBuilder = api.env.getIsBuilderComponentModel()
	const experiments = api.env.getExperiments()
	const servicesInfra =
		experiments?.['specs.thunderbolt.servicesInfra'] === true ||
		experiments?.['specs.thunderbolt.servicesInfra'] === 'true'
	const shouldLoadPageFeature = isBuilder || servicesInfra

	if (!shouldLoadPageFeature) {
		return { shouldLoadPageFeature: false }
	}

	return {
		shouldLoadPageFeature: true,
		pageConfig: {},
	}
}

export const pageConfig: PageConfigEntry<SdkStateServicePageConfig> = {
	name,
	configFactory: sdkStateServicePageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
